import React from 'react';
import {useTranslation} from 'react-i18next';
import {PLACEHOLDER_CLIENT, PLACEHOLDER_PERIOD, placeholderNotes} from './promptPlaceholders';

const RAW = {interpolation: {escapeValue: false}};

/**
 * La frase del copy ya nombra al marcador («{cliente} se completa solo…»): se lo dibuja como chip
 * DENTRO de la frase en vez de repetirlo adelante. Si una traducción no lo incluye, la frase va sola.
 */
function withTokenChip(text, token, unknown) {
    const index = text.indexOf(token);
    if (index < 0) return text;
    return (
        <>
            {text.slice(0, index)}
            <code className={`agp-var${unknown ? ' -unknown' : ''}`}>{token}</code>
            {text.slice(index + token.length)}
        </>
    );
}

/**
 * Qué va a pasar con cada `{marcador}` del texto, mientras se escribe. `{cliente}` y `{período}` se
 * explican; cualquier otro se marca en ámbar, porque la IA lo va a leer tal cual (y el Backend se lo
 * declara como marcador sin completar). Un prompt para todos los clientes sin `{cliente}` lleva un
 * consejo: casi siempre es el nombre de un cliente escrito a mano.
 */
export function PlaceholderNotes({text, isAllClients, clientName}) {
    const {t} = useTranslation();
    const {notes, tipClient} = placeholderNotes(text, isAllClients);
    if (notes.length === 0 && !tipClient) return null;

    const lineFor = ({token, kind}) => {
        const literal = `{${token}}`;
        if (kind === PLACEHOLDER_CLIENT) {
            const line = isAllClients || !clientName
                ? t('prompt_editor.ph_cliente_all')
                : t('prompt_editor.ph_cliente_one', {client: clientName, ...RAW});
            return withTokenChip(line, literal, false);
        }
        if (kind === PLACEHOLDER_PERIOD) {
            // El copy nombra `{período}`; si el texto usa la variante sin tilde, se muestra la suya.
            return withTokenChip(t('prompt_editor.ph_periodo').replace('{período}', literal), literal, false);
        }
        return withTokenChip(t('prompt_editor.ph_unknown', {token: literal, ...RAW}), literal, true);
    };

    return (
        <ul className="agp-editor__notes" aria-live="polite">
            {notes.map((note) => (
                <li key={note.token}
                    className={`agp-editor__note${note.kind === PLACEHOLDER_CLIENT || note.kind === PLACEHOLDER_PERIOD
                        ? '' : ' -unknown'}`}>
                    {lineFor(note)}
                </li>
            ))}
            {tipClient && (
                <li className="agp-editor__note -tip">
                    {withTokenChip(t('prompt_editor.ph_tip_cliente'), '{cliente}', false)}
                </li>
            )}
        </ul>
    );
}
